import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../config/config";
import { getToken } from "../../utils/localStorageMethods";

const apiUrl = config.Url;

const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/tracking`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("ngrok-skip-browser-warning", true);
    }
    return headers;
  },
});

export const trackingSlice = createApi({
  reducerPath: "trackingSlice",
  baseQuery: baseQuery,
  tagTypes: ["tracking"],
  endpoints: (builder) => ({
    getActiveTrips: builder.query({
      query: () => `/active-trip`,
      providesTags: ["tracking"],
    }),
  }),
});

export const { useGetActiveTripsQuery } = trackingSlice;
